/**
 * Calculates optimal parameters based on workflow task count
 */
export function getOptimalParametersForTaskCount(taskCount: number) {
  if (taskCount <= 20) {
    // Small problems: Lower population, fewer iterations, fewer memeplexes
    return {
      iterations: 150,
      initialPopulation: 180,
      crossoverRate: 75,
      mutationRate: 18,
      memeplexCount: 8,
    };
  } else if (taskCount <= 50) {
    // Medium problems: Balanced defaults (optimal for SFLA-GA)
    return {
      iterations: 200,
      initialPopulation: 250,
      crossoverRate: 80,
      mutationRate: 15,
      memeplexCount: 12,
    };
  } else {
    // Large problems: Higher population, more iterations, more memeplexes
    return {
      iterations: 300,
      initialPopulation: 350,
      crossoverRate: 85,
      mutationRate: 12,
      memeplexCount: 18,
    };
  }
}

